import angular from 'angular';
import { AngularServices } from '../../../modules/core';
import Browser from './browser';
export default angular
    .module('doxy.common.services.browser', [])
    .factory(AngularServices.Browser, function () {
    return new Browser();
}).name;
